import { render, staticRenderFns } from "./averageNumberOfServiceChart.vue?vue&type=template&id=465472c7"
import script from "./averageNumberOfServiceChart.vue?vue&type=script&lang=js"
export * from "./averageNumberOfServiceChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports